import styled, { css } from 'styled-components';
import { pxToRem, slideInOut } from 'Styles/utils/utils';
import { TABLET_WIDTH } from 'Styles/variables/sizes';

export const BackButton = styled.button`
  display: none;
  align-items: center;
  font-size: ${({ theme: { fontSizes } }) => pxToRem(fontSizes.s)};
  font-weight: bold;
  line-height: 1.43;
  padding: 0;
  cursor: pointer;
  svg {
    transform: rotate(180deg);
    margin-right: ${pxToRem(18)};
  }

  @media screen and (max-width: ${TABLET_WIDTH}) {
    display: ${({ isSubContent }) => (isSubContent ? 'flex' : 'none')};
    font-family: 'Arboria';
    margin-bottom: ${pxToRem(20)};
  }
`;

const slideStyle = css`
  transform: translateX(100%);
  position: absolute;
  padding-top: ${pxToRem(14)};
  border: none;
  display: none;
  left: 0;
  right: 0;
  ${slideInOut}
`;

export const Container = styled.div`
  border: 1px solid ${({ theme: { colors } }) => colors.blue_5};
  border-radius: 14px;
  padding: ${({ theme: { reference } }) => reference.dimension_24};
  width: 100%;
  height: 100%;
  background: white;
  position: relative;
  display: flex;
  flex-direction: column;

  @media screen and (max-width: ${TABLET_WIDTH}) {
    ${slideStyle}
  }
`;
